import { useTranslation } from 'react-i18next';
import AreaDropdown from '../../shared/dropdowns/AreaDropdown.js';
import DataCollectionAdd from '../../shared/DataCollectionAdd.js';
import DateInput from '../../shared/inputs/DateInput.js';

const AddRainForm = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <input type="number" name="amount"
             placeholder={t('rainfall_placeholder')} required/>
      <AreaDropdown/>
      <DateInput name="date" required />
    </>
  );
}

const getBodyFromForm = (formData) => {
  const amount = Number(formData.get("amount"));
  const area  = formData.get("area");
  const date  = formData.get("date");
  return JSON.stringify({amount, area, date});
}

export const AddRain = (props) => {
  return (
    <DataCollectionAdd
      collection="rain"
      getBodyFromForm={getBodyFromForm}
      formElements={AddRainForm}
      onSuccess={props.onSuccess}
    />
  );
}

export default AddRain;
